import React from 'react';
import PropTypes from 'prop-types';

import {
  TimelineItem,
  TimelineSeparator,
  TimelineDot,
  TimelineConnector,
  TimelineContent,
  TimelineOppositeContent,
} from '@mui/lab';

import './hurricane-item.styles.scss';

export default function HurricaneItem({ storm, selectedLocation }) {
  const createData = (storm) => {
    return [
      ['ID:', storm.id],
      ['Category:', storm.stormCategory],
      ['Active:', storm.fullDateRange],
      ['In the area of interest'],
      ['Categories:', storm.aoiCategories.join(',')],
      ['Wind Speeds (kt):', storm.aoiWindSpeed === null ? 'Unknown' : storm.aoiWindSpeed],
    ];
  };

  console.log(selectedLocation);

  return (
    <TimelineItem sx={{ minHeight: 'fit-content' }}>
      <TimelineContent
        sx={{
          maxWidth: '50px',
          overflowWrap: 'break-word',
          padding: 0,
          color: 'rgb(100,100,100)',
          lineHeight: 1.2,
        }}
      >
        {storm.aoiDateRange}
      </TimelineContent>
      <TimelineSeparator>
        <TimelineDot sx={{ backgroundColor: '#1976D2' }} />
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineOppositeContent
        sx={{ width: 'calc(100% - 74px)', padding: '6px 0px 6px 6px' }}
      >
        <div className='hurricane-item'>
          <div className='hurricane-item-spacer'>
            <div className='hurricane-item-header'>{storm.name}</div>
            {createData(storm).map((row) =>
              row.length === 1 ? (
                <div key={row[0]} className='hurricane-item-in-aoi'>
                  {row[0]}
                </div>
              ) : (
                <div key={row[0]} className='hurricane-item-row'>
                  <div className='hurricane-item-label'>{row[0]}</div>
                  <div className='hurricane-item-value'>{row[1]}</div>
                </div>
              )
            )}

            <hr/>

            <div className='hurricane-item-link'>
              <p>To see more storm details, go <a href='https://coast.noaa.gov/hurricanes/#map=4/32/-80' target='_blank' rel='noreferrer'>here</a> and search for this storm ({storm.name}) or the current location ({selectedLocation.name}).</p>
              
              {/* These links are broken as of 6/15/2026, but they may come back eventually, so they are left here for now. */}
              {/* <a href={storm.url} target='_blank' rel='noreferrer'>
                More Storm Details
              </a> */}
            </div>
          </div>
        </div>
      </TimelineOppositeContent>
    </TimelineItem>
  );
}

HurricaneItem.propTypes = {
  storm: PropTypes.object,
  selectedLocation: PropTypes.object,
};